import { FundingOpportunities } from '@platform/client';
import { CommunityCard } from '../CommunityCard';
import { ViewAllCard } from './ViewAllCard';

export const FundingOpportunitySegment = () => {
  const previewFundingOpportunities = FundingOpportunities.useGetFundingOpportunities({
    page: 0,
    limit: 3,
    sort: 'date:ASC',
  });

  return (
    <div data-testid='fundingSegment'>
      <h1 className='text-display-sm font-gray-700 pt-5'>Funding opportunities</h1>
      <div className='w-full mt-4 mb-4 bg-white rounded-xl p-4 border border-gray-100 '>
        {previewFundingOpportunities.data?.map((opportunity) => {
          return (
            <CommunityCard
              key={opportunity.id}
              title={opportunity.title}
              description={opportunity.description}
              date={new Date(opportunity.date)}
              link={opportunity.link ?? undefined}
            />
          );
        })}
        <ViewAllCard link='/funding-opportunities' />
      </div>
    </div>
  );
};
